import { render } from "./PagoExterno.vue?vue&type=template&id=684f555c&scoped=true"
import script from "./PagoExterno.vue?vue&type=script&lang=js"
export * from "./PagoExterno.vue?vue&type=script&lang=js"

import "./PagoExterno.vue?vue&type=style&index=0&id=684f555c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-684f555c"]])

export default __exports__